import { Tooltip } from "@blueprintjs/core";
import { ICellRendererParams } from "ag-grid-community";
import { getFuelTypeGlyph } from "in_queue/icons/fuelType/FuelTypeIcon";
import { formatFuelType } from "types/queueProjectRelatednessType";
import css from "./FuelTypePill.module.scss";
import tableCss from "./TableStyles.module.scss";

const FUEL_ICON_SIZE = 14;

// One pill around the icon and the label, tinted with the fuel's accent. The
// label picks up the column-header treatment so the two read as one system.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FuelTypePillRenderer: any = (params: ICellRendererParams) => {
    const fuelType = params.value;
    if (!fuelType) {
        return <span className={tableCss["muted-cell"]}>-</span>;
    }
    const { Icon, color } = getFuelTypeGlyph(fuelType);
    const label = formatFuelType(fuelType);
    return (
        <Tooltip
            content={label}
            placement="bottom-start"
            compact
            className={css["FuelTypePill-tooltip"]}
        >
            <span
                className={css["FuelTypePill"]}
                style={{ backgroundColor: `${color}26`, color }}
            >
                <Icon
                    className={css["FuelTypePill-icon"]}
                    width={FUEL_ICON_SIZE}
                    height={FUEL_ICON_SIZE}
                />
                <span className={css["FuelTypePill-label"]}>{label}</span>
            </span>
        </Tooltip>
    );
};
